import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { GlobalErrorHandler } from './global-error.handler';
import { ErrorDialogComponent } from './modal/error-dialog/error-dialog.component';
import { ErrorDialogService } from './modal/error-dialog.service';
import { InfoDialogComponent } from './modal/info-dialog/info-dialog.component';
import { InfoDialogService } from './modal/info-dialog.service';
import { ProgressDialogComponent } from './modal/progress-dialog/progress-dialog.component';
import { ProgressDialogService } from './modal/progress-dialog.service';
import { AuthInterceptor } from './auth.interceptor';
import { HttpLoggingInterceptor } from './http.logging.interceptor';
import { NxProgressbarModule } from '@aposin/ng-aquila/progressbar';

@NgModule({
	declarations: [ErrorDialogComponent, InfoDialogComponent,ProgressDialogComponent],
	imports: [CommonModule, NxProgressbarModule],
	providers: [
		ErrorDialogService, InfoDialogService, ProgressDialogService,
		{
			provide: ErrorHandler,
			useClass: GlobalErrorHandler,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpLoggingInterceptor,
			multi: true,
		},
	],
	exports: [ErrorDialogComponent, InfoDialogComponent, ProgressDialogComponent]
})
export class InterceptorsModule {}
